import { Button, Link } from '@mui/material';
import { useFormContext } from './FormContext';
import { useScanContext } from './ScanContext';
import { useScrollTargetContext } from './ScrollTargetContext';
import { TOcrData } from './types';

export interface ManualEntryTriggerProps {
  variant: 'link' | 'button';
  children: React.ReactNode;
  resetFormData?: boolean;
}

export default function ManualEntryTrigger({
  variant,
  resetFormData = false,
  children,
}: Readonly<ManualEntryTriggerProps>): JSX.Element {
  const {
    state: { formData },
    setFormData,
  } = useFormContext();
  const { bypassScan } = useScanContext();
  const { scrollToTarget } = useScrollTargetContext();

  const handleManualEntry = (isResetFormData: boolean) => {
    if (isResetFormData) {
      setFormData({} as TOcrData);
    } else {
      // If formData is null (not initialized), set it to empty object to show the OCR form
      if (!formData) {
        setFormData({} as TOcrData);
      }
      // otherwise, keep the existing formData (could be partially filled from previous OCR)
    }
    bypassScan();
    // Scroll to OCR form after state updates
    scrollToTarget('ocr-editor');
  };

  const handleClick = () => {
    handleManualEntry(resetFormData);
  };

  if (variant === 'link') {
    return (
      <Link data-action="manual-entry" sx={{ cursor: 'pointer' }} onClick={handleClick}>
        {children}
      </Link>
    );
  }

  return (
    <Button variant="text" onClick={handleClick} data-action="manual-entry">
      {children}
    </Button>
  );
}
